'use client';
import { useField, Field } from 'formik';

import { classNames } from '@repo/ui/src/utils/classNames';
import { TextareaHTMLAttributes, type Ref } from 'react';

export interface InputProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  name: string;
  className?: string;
  inputStyles?: string;
  ref?: Ref<HTMLTextAreaElement>;
}

const TextArea = ({ label, className, inputStyles, ref, ...props }: InputProps) => {
  const [field, meta] = useField(props);

  return (
    <div className={classNames('w-full', className)}>
      <label className="w-full flex flex-col	tra-text-web-body-s">
        {label && <span className="tra-text-web-heading-7 mb-6 dark:text-warm-100">{label}</span>}
      </label>
      <Field
        innerRef={ref}
        as="textarea"
        className={classNames(
          'tra-input-text',
          'tra-text-web-body-m h-[180px] py-5 px-4 resize-none border-neutral-500 w-full',
          meta.touched && meta.error && 'border-red-400',
          inputStyles,
        )}
        {...field}
        {...props}
      />
      {meta.touched && meta.error ? (
        <span className="tra-input-error" data-testid="input-error">
          {meta.error}
        </span>
      ) : null}
    </div>
  );
};

export default TextArea;
